(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  /*
    Infinite scroll for collection pages.

    Locksmith hides locked products inside the Liquid loop, so a page of results
    can render fewer products than the page size, or none at all. The previous
    version only loaded the next page when the trigger *entered* the viewport.
    When a fetched page added nothing, the trigger never left the viewport, the
    observer never fired again, and the grid sat on "Loading..." until the
    shopper scrolled or resized. This version keeps loading until the trigger is
    pushed out of view or there are no pages left, fetches only this section via
    the Section Rendering API (not the full page), and shows an empty state when
    nothing is visible.
  */
  class InfiniteScroll {
    constructor() {
      this.productGrid = document.getElementById('product-grid');
      this.trigger = document.getElementById('infinite-scroll-trigger');
      this.nextPageUrlElement = document.getElementById('next-page-url');
      this.emptyState = document.getElementById('collection-empty');
      this.sectionId = this.productGrid ? this.productGrid.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '') : null;
      this.isLoading = false;
      this.rootMargin = 400;

      if (!this.productGrid) return;

      if (this.trigger && this.nextPageUrlElement) {
        this.init();
      } else {
        this.updateEmptyState();
      }
    }

    init() {
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadMoreProducts();
        },
        { rootMargin: this.rootMargin + 'px' }
      );
      this.observer.observe(this.trigger);
    }

    productCount() {
      return this.productGrid.querySelectorAll(':scope > .product-card').length;
    }

    triggerInView() {
      if (!this.trigger || !this.trigger.isConnected) return false;
      const rect = this.trigger.getBoundingClientRect();
      return rect.top < window.innerHeight + this.rootMargin && rect.bottom > -this.rootMargin;
    }

    buildUrl(url) {
      if (!this.sectionId) return url;
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', this.sectionId);
      return u.toString();
    }

    async loadMoreProducts() {
      if (this.isLoading || !this.nextPageUrlElement) return;

      const nextPageUrl = this.nextPageUrlElement.dataset.url;
      if (!nextPageUrl) return this.finish();

      this.isLoading = true;
      let keepGoing = false;

      try {
        const response = await fetch(this.buildUrl(nextPageUrl));
        if (!response.ok) throw new Error('HTTP ' + response.status);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        doc.querySelectorAll('#product-grid > .product-card').forEach((product) => {
          product.style.opacity = '0';
          product.style.transition = 'opacity 0.5s ease-in';
          this.productGrid.insertBefore(product, this.trigger);
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              product.style.opacity = '1';
            });
          });
        });

        const nextUrlElement = doc.getElementById('next-page-url');
        if (nextUrlElement && nextUrlElement.dataset.url) {
          this.nextPageUrlElement.dataset.url = nextUrlElement.dataset.url;
          keepGoing = true;
        } else {
          this.finish();
        }
      } catch (error) {
        console.error('Error loading more products:', error);
      } finally {
        this.isLoading = false;
      }

      // If the page added few or no visible products, the trigger is still on
      // screen and the observer will not fire again. Keep going ourselves.
      if (keepGoing && this.triggerInView()) {
        requestAnimationFrame(() => this.loadMoreProducts());
      }
    }

    finish() {
      if (this.observer) this.observer.disconnect();
      if (this.trigger) this.trigger.remove();
      if (this.nextPageUrlElement) this.nextPageUrlElement.remove();
      this.trigger = null;
      this.nextPageUrlElement = null;
      this.updateEmptyState();
    }

    updateEmptyState() {
      if (this.emptyState && this.productCount() === 0) {
        this.emptyState.style.display = '';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new InfiniteScroll());
  } else {
    new InfiniteScroll();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
  class InfiniteScroll {
    constructor() {
      this.productGrid = document.getElementById('product-grid');
      this.trigger = document.getElementById('infinite-scroll-trigger');
      this.nextPageUrlElement = document.getElementById('next-page-url');
      this.isLoading = false;
      
      if (this.trigger && this.nextPageUrlElement) {
        this.init();
      }
    }
    
    init() {
      this.observer = new IntersectionObserver(
        (entries) => this.handleIntersection(entries),
        { rootMargin: '200px' }
      );
      this.observer.observe(this.trigger);
    }
    
    handleIntersection(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.isLoading) {
          this.loadMoreProducts();
        }
      });
    }
    
    async loadMoreProducts() {
      if (this.isLoading) return;
      
      const nextPageUrl = this.nextPageUrlElement.dataset.url;
      if (!nextPageUrl) return;
      
      this.isLoading = true;
      
      try {
        const response = await fetch(nextPageUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Extract new items
        const newItems = doc.querySelectorAll('#product-grid > .group');
        newItems.forEach((item) => {
          item.style.opacity = '0';
          item.style.transition = 'opacity 0.5s ease-in';
          this.productGrid.insertBefore(item, this.trigger);
          
          // Trigger fade-in after a small delay
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              item.style.opacity = '1';
            });
          });
        });
        
        // Check if there's another page
        const nextUrlElement = doc.getElementById('next-page-url');
        if (nextUrlElement && nextUrlElement.dataset.url) {
          this.nextPageUrlElement.dataset.url = nextUrlElement.dataset.url;
        } else {
          // No more pages - remove trigger and observer
          this.observer.disconnect();
          this.trigger.remove();
          this.nextPageUrlElement.remove();
        }
      } catch (error) {
        console.error('Error loading more items:', error);
      } finally {
        this.isLoading = false;
      }
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new InfiniteScroll());
  } else {
    new InfiniteScroll();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Search overlay functionality
  (function () {
    const searchToggle = document.querySelector('.header__search-toggle');
    const searchOverlay = document.querySelector('.header__search-overlay');
    const searchClose = document.querySelector('.header__search-close');
    const searchInput = document.querySelector('#header-search');

    if (!searchToggle || !searchOverlay || !searchClose) return;

    function openSearch() {
      searchOverlay.classList.add('is-visible');
      if (searchInput) {
        setTimeout(() => searchInput.focus(), 100);
      }
    }

    function closeSearch() {
      searchOverlay.classList.remove('is-visible');
    }

    searchToggle.addEventListener('click', openSearch);
    searchClose.addEventListener('click', closeSearch);

    // Close on escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchOverlay.classList.contains('is-visible')) {
        closeSearch();
      }
    });

    // Close when clicking outside
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) {
        closeSearch();
      }
    });
  })();

  (function () {
    const header = document.querySelector('.header-expandable');
    if (!header) return;

    const headerMenu = header.querySelector('.header__menu');
    const headerDropdown = header.querySelector('.header__dropdown');
    const mobileMenuBtn = header.querySelector('.header__mobile-menu-btn');

    if (!headerDropdown) return;

    let isOpen = false;
    let hoverTimeout = null;
    let activeLink = null;
    let activeSubmenu = null;

    function setActiveLink(link) {
      // Remove is-active from previous link
      if (activeLink && activeLink !== link) {
        activeLink.classList.remove('is-active');
      }
      // Add is-active to current link
      if (link) {
        link.classList.add('is-active');
        activeLink = link;
      }
    }

    function setActiveSubmenu(linkTitle) {
      // Hide all submenus
      const allSubmenus = header.querySelectorAll('.header__nav-submenu');
      allSubmenus.forEach((submenu) => {
        submenu.classList.remove('is-active');
      });

      // Show the submenu for this link
      if (linkTitle) {
        const targetSubmenu = header.querySelector(`.header__nav-submenu[data-nav-for="${linkTitle}"]`);
        if (targetSubmenu) {
          targetSubmenu.classList.add('is-active');
          activeSubmenu = targetSubmenu;
        }
      }
    }

    function openDropdown(linkTitle, link) {
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }
      
      // Check if there's a submenu for this link
      const hasSubmenu = linkTitle && header.querySelector(`.header__nav-submenu[data-nav-for="${linkTitle}"]`);
      
      // If link has no submenu, close the dropdown
      if (!hasSubmenu) {
        closeDropdown();
        return;
      }
      
      if (linkTitle) {
        setActiveSubmenu(linkTitle);
      }
      if (link) {
        setActiveLink(link);
      }
      if (!isOpen) {
        isOpen = true;
        header.classList.add('is-open');
      }
    }

    function closeDropdown() {
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
      }
      hoverTimeout = setTimeout(() => {
        if (isOpen) {
          isOpen = false;
          header.classList.remove('is-open');
          // Remove is-active from all links when closing
          if (activeLink) {
            activeLink.classList.remove('is-active');
            activeLink = null;
          }
        }
      }, 100);
    }

    function toggleDropdown() {
      if (isOpen) {
        isOpen = false;
        header.classList.remove('is-open');
      } else {
        isOpen = true;
        header.classList.add('is-open');
      }
    }

    function cancelClose() {
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }
    }

    // Check if the target is a navigation link (not search, account, cart, or logo)
    function isNavigationLink(element) {
      if (!element || element.tagName !== 'A') return false;

      // Check if it's inside the header__menu
      const menu = header.querySelector('.header__menu');
      if (!menu || !menu.contains(element)) return false;

      // Exclude search, account, cart, and logo links
      const href = element.getAttribute('href') || '';
      const isSearch = href.includes('/search') || element.textContent.trim().toLowerCase() === 'search';
      const isAccount = href.includes('/account') || element.textContent.trim().toLowerCase() === 'account';
      const isCart = href.includes('/cart') || element.textContent.trim().toLowerCase() === 'cart';
      const isLogo = element.closest('a[href="/"]') && element.querySelector('img[alt*="logo" i]');

      return !isSearch && !isAccount && !isCart && !isLogo;
    }

    // Helper to check if we're on mobile
    function isMobile() {
      return window.innerWidth <= 768;
    }

    // Mobile: Handle hamburger button click
    if (mobileMenuBtn) {
      mobileMenuBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (isMobile()) {
          // If closing the menu, reset submenu state
          if (isOpen) {
            const mobileMenuContainer = header.querySelector('.header__mobile-menu-container');
            if (mobileMenuContainer) {
              mobileMenuContainer.classList.remove('show-submenu');
            }
          }
          toggleDropdown();
        }
      });
    }

    // Desktop: Handle mouseenter on header - check if it's a nav link
    if (headerMenu && !isMobile()) {
      header.addEventListener('mouseenter', function (e) {
        if (!isMobile() && isNavigationLink(e.target)) {
          const linkTitle = e.target.getAttribute('data-link-title') || e.target.textContent.trim();
          openDropdown(linkTitle, e.target);
        }
      });

      // Handle mouseleave on header - close dropdown
      header.addEventListener('mouseleave', function () {
        if (!isMobile()) {
          closeDropdown();
        }
      });

      // Keep dropdown open when moving from link to dropdown
      headerDropdown.addEventListener('mouseenter', function () {
        if (!isMobile() && isOpen) {
          cancelClose();
        }
      });

      // Handle hover on navigation links specifically
      const navLinks = headerMenu.querySelectorAll('a.header__nav-link');
      navLinks.forEach((link) => {
        link.addEventListener('mouseenter', function () {
          if (!isMobile() && isNavigationLink(this)) {
            const linkTitle = this.getAttribute('data-link-title') || this.textContent.trim();
            openDropdown(linkTitle, this);
          }
        });
      });
    }

    // Mobile submenu navigation
    const mobileMenuContainer = header.querySelector('.header__mobile-menu-container');
    const mobileMenuItems = header.querySelectorAll('.header__mobile-menu-item');
    const mobileBackBtn = header.querySelector('.header__mobile-back-btn');
    const mobileSubmenuTitle = header.querySelector('.header__mobile-submenu-title');
    const mobileNestedBackBtn = header.querySelector('.header__mobile-nested-back-btn');
    const mobileNestedSubmenuTitle = header.querySelector('.header__mobile-nested-submenu-title');

    // Handle mobile menu item clicks (first level)
    if (mobileMenuItems && mobileMenuContainer) {
      mobileMenuItems.forEach((item) => {
        item.addEventListener('click', function (e) {
          if (isMobile()) {
            e.preventDefault();
            e.stopPropagation();
            const title = this.getAttribute('data-title');

            // Store the current parent context for nested navigation
            mobileMenuContainer.setAttribute('data-current-parent', title);

            // Update submenu title
            if (mobileSubmenuTitle) {
              mobileSubmenuTitle.textContent = title;
            }

            // Show the correct submenu content
            const allSubmenuItems = header.querySelectorAll('.header__mobile-submenu-items');
            allSubmenuItems.forEach((item) => {
              item.style.display = 'none';
            });
            
            const targetSubmenu = header.querySelector(`.header__mobile-submenu-items[data-parent="${title}"]`);
            if (targetSubmenu) {
              targetSubmenu.style.display = 'block';
            }

            // Show submenu with slide animation
            mobileMenuContainer.classList.add('show-submenu');
            mobileMenuContainer.classList.remove('show-nested');
          }
        });
      });
    }

    // Handle submenu item wrappers (second level - items with children)
    const mobileSubmenuWrappers = header.querySelectorAll('.header__mobile-submenu-item-wrapper');
    if (mobileSubmenuWrappers && mobileMenuContainer) {
      mobileSubmenuWrappers.forEach((wrapper) => {
        wrapper.addEventListener('click', function (e) {
          if (isMobile()) {
            e.preventDefault();
            e.stopPropagation();
            const title = this.getAttribute('data-title');
            const parentContext = this.getAttribute('data-parent');

            // Update nested submenu title
            if (mobileNestedSubmenuTitle) {
              mobileNestedSubmenuTitle.textContent = title;
            }

            // Show the correct nested submenu content using both title and grandparent context
            const allNestedItems = header.querySelectorAll('.header__mobile-nested-items');
            allNestedItems.forEach((item) => {
              item.style.display = 'none';
            });
            
            // Use grandparent context to find the correct nested menu
            const targetNested = header.querySelector(`.header__mobile-nested-items[data-parent="${title}"][data-grandparent="${parentContext}"]`);
            if (targetNested) {
              targetNested.style.display = 'block';
            }

            // Show nested submenu with slide animation
            mobileMenuContainer.classList.add('show-nested');
          }
        });
      });
    }

    // Handle back button (from submenu to main menu)
    if (mobileBackBtn && mobileMenuContainer) {
      mobileBackBtn.addEventListener('click', function (e) {
        e.preventDefault();
        mobileMenuContainer.classList.remove('show-submenu');
        mobileMenuContainer.classList.remove('show-nested');
      });
    }

    // Handle nested back button (from nested submenu to submenu)
    if (mobileNestedBackBtn && mobileMenuContainer) {
      mobileNestedBackBtn.addEventListener('click', function (e) {
        e.preventDefault();
        mobileMenuContainer.classList.remove('show-nested');
      });
    }

    // Close dropdown when clicking outside on mobile
    document.addEventListener('click', function (e) {
      if (isOpen && isMobile()) {
        // Don't close if clicking on mobile menu items, back buttons, or their children
        if (
          e.target.closest('.header__mobile-menu-item') ||
          e.target.closest('.header__mobile-submenu-item-wrapper') ||
          e.target.closest('.header__mobile-back-btn') ||
          e.target.closest('.header__mobile-nested-back-btn')
        ) {
          return;
        }

        // Close if clicking outside the header, or on a regular link (but not the hamburger button)
        if (
          !header.contains(e.target) ||
          (e.target.closest('a[href]') && !e.target.closest('.header__mobile-menu-btn'))
        ) {
          isOpen = false;
          header.classList.remove('is-open');
          // Reset submenu when closing
          if (mobileMenuContainer) {
            mobileMenuContainer.classList.remove('show-submenu');
            mobileMenuContainer.classList.remove('show-nested');
          }
        }
      }
    });
  })();

  // Toggle header dark mode when entering footer
  (function () {
    const header = document.querySelector('.header-expandable');
    const footer = document.querySelector('footer');

    if (!header || !footer) return;

    // Get original dark mode setting from data attribute
    const originalDarkMode = header.getAttribute('data-dark-mode') === 'true';

    // Elements that need dark mode toggled - exclude dropdown images
    const headerTop = header.querySelector('.header__top');
    const darkModeElements = {
      text: header,
      images: headerTop ? headerTop.querySelectorAll('img') : [],
    };

    function toggleHeaderDarkMode(isDark) {
      // Toggle text color
      if (isDark) {
        darkModeElements.text.classList.remove('text-black');
        darkModeElements.text.classList.add('text-white');
      } else {
        darkModeElements.text.classList.remove('text-white');
        darkModeElements.text.classList.add('text-black');
      }

      // Toggle image inversion (only for header top images, not dropdown)
      darkModeElements.images.forEach((img) => {
        if (isDark) {
          img.classList.remove('invert');
        } else {
          img.classList.add('invert');
        }
      });
    }

    function checkHeaderFooterOverlap() {
      const headerRect = header.getBoundingClientRect();
      const footerRect = footer.getBoundingClientRect();

      // Check if any part of the header overlaps with the footer
      // Header overlaps if header's bottom is below footer's top AND header's top is above footer's bottom
      const isOverlapping = headerRect.bottom > footerRect.top && headerRect.top < footerRect.bottom;

      if (isOverlapping) {
        toggleHeaderDarkMode(false);
      } else {
        // Restore dark mode when not overlapping (includes scrolling back up)
        toggleHeaderDarkMode(originalDarkMode);
      }
    }

    // Check on scroll
    let ticking = false;
    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            checkHeaderFooterOverlap();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    // Initial check
    checkHeaderFooterOverlap();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.product-section');

    sections.forEach((section) => {
      const sectionId = section.dataset.sectionId;
      const thumbnails = section.querySelectorAll('.product-media-thumbnail');
      const mediaItems = section.querySelectorAll('.product-media-item');
      const mediaMain = section.querySelector('.product-media-main');

      if (!mediaItems.length) return;

      // Function to update active thumbnail
      function updateActiveThumbnail(index) {
        thumbnails.forEach((t) => t.classList.remove('active'));
        const activeThumbnail = section.querySelector(`.product-media-thumbnail[data-media-index="${index}"]`);
        if (activeThumbnail) {
          activeThumbnail.classList.add('active');
        }
      }

      // Intersection Observer to detect which image is in view
      // Desktop: observe viewport (null root), Mobile: observe container (mediaMain root)
      const isMobile = window.innerWidth < 1024;
      const observerOptions = {
        root: isMobile ? mediaMain : null,
        rootMargin: '-50% 0px -50% 0px',
        threshold: 0,
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = entry.target.dataset.mediaIndex;
            updateActiveThumbnail(index);
          }
        });
      }, observerOptions);

      // Observe all media items
      mediaItems.forEach((item) => {
        observer.observe(item);
      });

      // On page load, check which image is in view and update thumbnail
      function syncThumbnailToScroll() {
        if (window.innerWidth < 1024 && mediaMain) {
          // Mobile: check horizontal scroll
          const scrollLeft = mediaMain.scrollLeft;
          const itemWidth = mediaItems[0]?.offsetWidth || 0;
          if (itemWidth > 0) {
            const visibleIndex = Math.round(scrollLeft / itemWidth);
            updateActiveThumbnail(visibleIndex);
          }
        } else {
          // Desktop: check which image is closest to viewport center
          let closestIndex = 0;
          let closestDistance = Infinity;

          mediaItems.forEach((item, index) => {
            const rect = item.getBoundingClientRect();
            const itemCenter = rect.top + rect.height / 2;
            const viewportCenter = window.innerHeight / 2;
            const distance = Math.abs(itemCenter - viewportCenter);

            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          updateActiveThumbnail(closestIndex);
        }
      }

      // Sync on page load
      syncThumbnailToScroll();

      // Click handler for thumbnails - scroll to image
      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', function () {
          const index = this.dataset.mediaIndex;
          const targetImage = document.getElementById(`product-image-${sectionId}-${index}`);

          // Update active state immediately
          updateActiveThumbnail(index);

          if (targetImage) {
            // On mobile, scroll horizontally within the container
            if (window.innerWidth < 1024 && mediaMain) {
              const scrollLeft = targetImage.offsetLeft - mediaMain.offsetLeft;
              mediaMain.scrollTo({
                left: scrollLeft,
                behavior: 'smooth',
              });
            } else {
              // On desktop, scroll vertically on the page
              targetImage.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              });
            }
          }
        });
      });

      // Variant selection handler
      const variantOptions = section.querySelectorAll('.product-variant-option');
      const variantInput = section.querySelector(`#product-variant-id-${sectionId}`);

      variantOptions.forEach((option) => {
        option.addEventListener('click', function () {
          if (this.classList.contains('disabled')) return;

          const variantId = this.dataset.variantId;

          // Update hidden input
          if (variantInput) {
            variantInput.value = variantId;
          }

          // Update selected state
          variantOptions.forEach((opt) => opt.classList.remove('selected'));
          this.classList.add('selected');
        });
      });

      // Mobile carousel arrow navigation
      const prevButton = section.querySelector('.product-carousel-arrow-prev');
      const nextButton = section.querySelector('.product-carousel-arrow-next');

      if (prevButton && nextButton && mediaMain) {
        let currentIndex = 0;

        function scrollToIndex(index) {
          if (mediaItems[index]) {
            const targetImage = mediaItems[index];
            const scrollLeft = targetImage.offsetLeft - mediaMain.offsetLeft;
            mediaMain.scrollTo({
              left: scrollLeft,
              behavior: 'smooth',
            });
            currentIndex = index;
          }
        }

        prevButton.addEventListener('click', () => {
          const newIndex = currentIndex > 0 ? currentIndex - 1 : mediaItems.length - 1;
          scrollToIndex(newIndex);
        });

        nextButton.addEventListener('click', () => {
          const newIndex = currentIndex < mediaItems.length - 1 ? currentIndex + 1 : 0;
          scrollToIndex(newIndex);
        });

        // Update currentIndex when user swipes
        mediaMain.addEventListener('scroll', () => {
          const scrollLeft = mediaMain.scrollLeft;
          const itemWidth = mediaItems[0]?.offsetWidth || 0;
          if (itemWidth > 0) {
            currentIndex = Math.round(scrollLeft / itemWidth);
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  /*
    Infinite scroll for search results.

    Locksmith hides locked products inside the Liquid loop, so a page of results
    can render fewer products than the page size, or none at all. The previous
    version only loaded the next page when the trigger *entered* the viewport.
    When a fetched page added nothing, the trigger never left the viewport, the
    observer never fired again, and the grid sat on "Loading..." until the
    shopper scrolled or resized. This version keeps loading until the trigger is
    pushed out of view or there are no pages left, fetches only this section via
    the Section Rendering API (not the full page), and shows an empty state when
    nothing is visible.
  */
  class InfiniteScroll {
    constructor() {
      this.productGrid = document.getElementById('product-grid');
      this.trigger = document.getElementById('infinite-scroll-trigger');
      this.nextPageUrlElement = document.getElementById('next-page-url');
      this.emptyState = document.getElementById('collection-empty');
      this.sectionId = this.productGrid ? this.productGrid.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '') : null;
      this.isLoading = false;
      this.rootMargin = 400;

      if (!this.productGrid) return;

      if (this.trigger && this.nextPageUrlElement) {
        this.init();
      } else {
        this.updateEmptyState();
      }
    }

    init() {
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadMoreProducts();
        },
        { rootMargin: this.rootMargin + 'px' }
      );
      this.observer.observe(this.trigger);
    }

    productCount() {
      return this.productGrid.querySelectorAll(':scope > .product-card').length;
    }

    triggerInView() {
      if (!this.trigger || !this.trigger.isConnected) return false;
      const rect = this.trigger.getBoundingClientRect();
      return rect.top < window.innerHeight + this.rootMargin && rect.bottom > -this.rootMargin;
    }

    buildUrl(url) {
      if (!this.sectionId) return url;
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', this.sectionId);
      return u.toString();
    }

    async loadMoreProducts() {
      if (this.isLoading || !this.nextPageUrlElement) return;

      const nextPageUrl = this.nextPageUrlElement.dataset.url;
      if (!nextPageUrl) return this.finish();

      this.isLoading = true;
      let keepGoing = false;

      try {
        const response = await fetch(this.buildUrl(nextPageUrl));
        if (!response.ok) throw new Error('HTTP ' + response.status);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        doc.querySelectorAll('#product-grid > .product-card').forEach((product) => {
          product.style.opacity = '0';
          product.style.transition = 'opacity 0.5s ease-in';
          this.productGrid.insertBefore(product, this.trigger);
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              product.style.opacity = '1';
            });
          });
        });

        const nextUrlElement = doc.getElementById('next-page-url');
        if (nextUrlElement && nextUrlElement.dataset.url) {
          this.nextPageUrlElement.dataset.url = nextUrlElement.dataset.url;
          keepGoing = true;
        } else {
          this.finish();
        }
      } catch (error) {
        console.error('Error loading more products:', error);
      } finally {
        this.isLoading = false;
      }

      // If the page added few or no visible products, the trigger is still on
      // screen and the observer will not fire again. Keep going ourselves.
      if (keepGoing && this.triggerInView()) {
        requestAnimationFrame(() => this.loadMoreProducts());
      }
    }

    finish() {
      if (this.observer) this.observer.disconnect();
      if (this.trigger) this.trigger.remove();
      if (this.nextPageUrlElement) this.nextPageUrlElement.remove();
      this.trigger = null;
      this.nextPageUrlElement = null;
      this.updateEmptyState();
    }

    updateEmptyState() {
      if (this.emptyState && this.productCount() === 0) {
        this.emptyState.style.display = '';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new InfiniteScroll());
  } else {
    new InfiniteScroll();
  }

  } catch(e) { console.error(e); }
})();
})();
